import React from 'react';

import {MediaQuery, RadioButton} from '@optimaxdev/design-system';
import {ApplePayD, GooglePayD, Icon, PaypalTransparent} from '@optimaxdev/icons';
import classNames from 'classnames';

import {useMediaQuery} from 'react-responsive';

import {KlarnaTitle} from 'desktop/pages/checkout/components/paymentKlarnaPrimer/paymentKlarnaPrimer';
import {PAYMENTS} from 'desktop/pages/checkout/constants/paymentStep';

export type PropsType = {
    paymentKey: PAYMENTS;
    setSelectedPaymentMethod: React.Dispatch<React.SetStateAction<string>>;
    selectedPaymentMethod: string;
};

import * as CardsIcon from '../../../../../img/cards.svg';

import s from './paymentMethodOneStep.scss';

/**
 * dummy function to prevent event bubbling
 */
const doNothing = () => {};

const paymentsIcons: {
    [key in PAYMENTS]?: {
        title: React.ReactElement;
        rightSideIcon?: React.ReactElement;
    };
} = {
    [PAYMENTS.METHOD_PRIMER]: {
        rightSideIcon: <Icon height={23} icon={CardsIcon} label="CardsIcon" width={245} />,
        title: (
            <div className={s.primerCC}>
                <span>Credit card</span>
            </div>
        ),
    },
    [PAYMENTS.METHOD_PRIMER_APPLE_PAY]: {
        title: (
            <div className={s.applePay}>
                <Icon className={s.icon} icon={ApplePayD} />
            </div>
        ),
    },
    [PAYMENTS.METHOD_PRIMER_GOOGLE_PAY]: {
        title: (
            <div className={s.googlePay}>
                <Icon icon={GooglePayD} size="responsive" />
            </div>
        ),
    },
    [PAYMENTS.METHOD_PRIMER_KLARNA]: {
        title: <KlarnaTitle isLoading={false} />,
    },
    [PAYMENTS.METHOD_PRIMER_PAYPAL]: {
        title: (
            <div className={s.payPal}>
                <Icon icon={PaypalTransparent} size="responsive" />
            </div>
        ),
    },
};

/**
 * Edit payment method for checkout one step
 */
export const PaymentMethodOneStep: React.FC<PropsType> = ({
    paymentKey,
    selectedPaymentMethod,
    setSelectedPaymentMethod,
}) => {
    const isSmallScreen = useMediaQuery(MediaQuery.sm);

    const handleClick = () => {
        setSelectedPaymentMethod(paymentKey as PAYMENTS);
    };

    const isSelected = selectedPaymentMethod === paymentKey;

    return (
        <div
            className={classNames(s.wrapper, {
                [s.inactiveMethod]: !isSelected,
            })}
        >
            <div className={s.titleWrap}>
                <button onClick={handleClick} type="button">
                    <div className={s.block}>
                        <RadioButton
                            isChecked={isSelected}
                            onChange={doNothing}
                            size={isSmallScreen ? 'medium' : 'small'}
                            value={paymentKey}
                        />{' '}
                        <div className={s.title}>
                            {paymentsIcons[paymentKey as PAYMENTS]?.title}
                        </div>
                    </div>
                </button>
                {paymentsIcons[paymentKey as PAYMENTS]?.rightSideIcon || null}
            </div>
        </div>
    );
};
